import React, { FC } from 'react';
import { Link } from '@/navigation';
import { TypeProduct as InternalProduct } from '@/lib/api/productCatalog/types';

export interface ReplacementPartsBreadcrumbTreeProps {
  rootText: string;
  rootUrl: string;
  parentProduct: InternalProduct;
  parentComponent?: InternalProduct;
}

const ReplacementPartsBreadcrumbTree: FC<
  ReplacementPartsBreadcrumbTreeProps
> = ({ rootUrl, rootText, parentProduct, parentComponent }) => {
  return (
    <div data-testid="breadcrumb-tree" className="flex flex-wrap gap-1">
      <div className="flex gap-1">
        <Link href={rootUrl} className="hover:text-indigo">
          {rootText}
        </Link>
        <p>/</p>
      </div>
      {parentComponent ? (
        <div className="flex gap-1">
          <Link
            href={`${rootUrl}/${parentProduct.anchor}`}
            className="hover:text-indigo"
          >
            {parentProduct.name}
          </Link>
          <p>/</p>
          <span>{parentComponent.name}</span>
        </div>
      ) : (
        <span>{parentProduct.name}</span>
      )}
    </div>
  );
};

export default React.memo(ReplacementPartsBreadcrumbTree);
